import { UserModel } from "model/User.model";
import AddUserRequest from "model/api/AddUserRequest.model";
import InviteUserRequest from "model/api/InviteUserRequest.model";
import UpdateUserRequest from "model/api/UpdateUserRequest.model";
import UserSpec from "model/api/UserSpec.model";
import BaseApiService from "service/BaseApi.service";

const DEFAULT_PATH = "/v1/user";
const DEFAULT_PATH_V2 = "/v2/user";

class UserService extends BaseApiService {
  /**===============================
            Constructor
  ================================**/
  constructor() {
    super();
    // this.defaultLimit = //Put service specific default limit here;
  }

  //Properties
  private readonly defaultPath: string = DEFAULT_PATH;
  private readonly defaultPathV2: string = DEFAULT_PATH_V2;
  /**===============================
          Standard API Calls
  ================================**/

  getUsers(start = 0, limit = this.defaultLimit, search = "") {
    const url = `${this.defaultPath}${search}`;
    return this.makeGetRequestWithAuth(url);
  }

  getById(id: string) {
    const url = `${this.defaultPath}/${id}`;
    return this.makeGetRequestWithAuth(url);
  }

  getMe() {
    const url = `/v1/me`;
    return this.makeGetRequestWithAuth(url);
  }

  create(payload: AddUserRequest, isAuth0Enabled = false) {
    const url = isAuth0Enabled ? `${this.defaultPathV2}` : `${this.defaultPath}`;
    return this.makePostRequest(url, payload);
  }

  invite(payload: InviteUserRequest) {
    const url = `${this.defaultPath}/invite`;
    return this.makePostRequestWithAuth(url, payload);
  }

  update(id: string, payload: UpdateUserRequest) {
    const url = `${this.defaultPath}/${id}`;
    return this.makePutRequestWithAuth(url, payload);
  }

  delete(id: string) {
    const url = `${this.defaultPath}/${id}`;
    return this.makeDeleteRequestWithAuth(url);
  }

  /**===============================
        Custom API Calls
  ================================**/

  /**===============================
          Standard Transformers
  ================================**/

  convertAPIResToModel = (apiResponse: UserSpec): UserModel => {
    const user = new UserModel();

    if (apiResponse.uuid) user.uuid = apiResponse.uuid;
    if (apiResponse.first_name) user.firstName = apiResponse.first_name;
    if (apiResponse.last_name) user.lastName = apiResponse.last_name;
    if (apiResponse.email) user.email = apiResponse.email;
    if (apiResponse.org_uuid) user.orgUuid = apiResponse.org_uuid;

    return user;
  };

  convertModelToAPIReq = (user: UserModel): AddUserRequest => {
    const addUserRequest = new AddUserRequest();

    const projectSpec = new UserSpec();
    if (user.uuid) projectSpec.uuid = user.uuid;
    if (user.firstName) projectSpec.first_name = user.firstName;
    if (user.lastName) projectSpec.last_name = user.lastName;
    if (user.email) projectSpec.email = user.email;
    if (user.orgUuid) projectSpec.org_uuid = user.orgUuid;
    addUserRequest.user = projectSpec;

    return addUserRequest;
  };
}

export default new UserService();
